import React, { useEffect, useState } from "react";
import { Typography, Button } from "@mui/material";
import BasicTable from "../Table/Material";
import useApi from "../../Hooks/useApi";
import { usePagination } from "../../Hooks/usePagination";
import useWindowHeight from "../../Hooks/useWindowHeight";

const SurveyCityListModal = ({ survey }) => {
  const { surveyId, surveyName } = survey;
  const { request, loading } = useApi();
  const [surveyCityData, setSurveyCityData] = useState();
  const paginateProps = usePagination();
  const windowHeight = useWindowHeight();

  const columns = [
    {
      id: "name",
      label: "City Name",
      minWidth: 170,
    },
    {
      id: "type",
      label: "City Type",
      minWidth: 170,
      renderCell: (row) => <>{row.type.replace("_", " ")}</>,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },
    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align: "center",
      renderCell: (row) => (
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            // Handle view details action
       
          }}
        >
          Remove
        </Button>
      ),
    },
  ];

  const fetchSurveyCities = async () => {
    try {
      const response = surveyId
        ? await request(
            "GET",
            `/v1/survey/city-mapping/${surveyId}`,
            {},
            "survey_service"
          )
        : undefined;

      setSurveyCityData(response?.cities);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSurveyCities();
  }, []);

  return (
    <div className=" relative ">
      <div className="flex items-center justify-between">
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            fontSize: {
              xs: "1.25rem",
              sm: "1.50rem",
              md: "1.75rem",
              lg: "2rem",
            },
          }}
          className="w-full py-4"
        >
          Manage Survey City List - {surveyName}
        </Typography>
      </div>

      {surveyCityData && surveyCityData.length && !loading ? (
        <BasicTable
          style={{ width: "90%", marginRight: "auto", marginLeft: "auto" }}
          maxHeight={Math.max(windowHeight * 0.3, 100)}
          columns={columns}
          data={surveyCityData}
          paginateProps={paginateProps}
        />
      ) : (
        <div className="text-center text-lg">No city added</div>
      )}
    </div>
  );
};

export default SurveyCityListModal;
